import { render, staticRenderFns } from "./Conclusion.vue?vue&type=template&id=efb15d38&scoped=true&"
import script from "./Conclusion.vue?vue&type=script&lang=js&"
export * from "./Conclusion.vue?vue&type=script&lang=js&"
import style0 from "./Conclusion.vue?vue&type=style&index=0&id=efb15d38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb15d38",
  null
  
)

export default component.exports